/*
 * Staff/customer discount (aico) — cart display.
 *
 * Shopify's cart doesn't know about the aico discount (it lives in the
 * `_price_item_discount` line-item property that the checkout reroute applies), so the
 * cart page renders full prices. This repurposes those properties to show the discounted
 * line prices + subtotal/total on the cart page, matching what the shopper pays at checkout.
 *
 * Display-only: it rewrites the number inside each price element while preserving the
 * theme's exact money formatting (currency symbol, Swiss apostrophe thousands).
 * Runs on load and re-runs after cart AJAX updates.
 */
(function () {
  'use strict';

  var NUM_RE = /[\d'’.,]+/;

  function fmtSwiss(cents) {
    var s = (cents / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return s[0] + '.' + s[1];
  }
  // Replace only the numeric run in an element, keeping "CHF"/format intact.
  function setNumber(el, cents) {
    if (el && NUM_RE.test(el.textContent)) el.textContent = el.textContent.replace(NUM_RE, fmtSwiss(cents));
  }
  function pidCents(item) {
    var p = item.properties && item.properties['_price_item_discount'];
    if (!p) return null;
    var v = parseFloat(String(p).replace(/,/g, ''));
    return isNaN(v) ? null : Math.round(v * 100);
  }

  var cartUrl = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js';
  var observer = null, target = null, debounce = null;

  // Capture an element's original (full-price) text once per theme render, so re-runs are
  // idempotent. The theme re-creates these elements on qty/remove, which clears the marker
  // and lets us re-capture the fresh full price.
  function originalText(el) {
    var stored = el.getAttribute('data-aico-orig');
    if (stored == null) { stored = el.textContent; el.setAttribute('data-aico-orig', stored); }
    return stored;
  }
  function originalCents(el) {
    var s = originalText(el).replace(/[^\d.,]/g, '').replace(/[’']/g, '');
    // Swiss "1'229.00": apostrophes already stripped; keep dot decimal.
    var v = parseFloat(s.replace(/,(?=\d{2}$)/, '.').replace(/,/g, ''));
    return isNaN(v) ? null : Math.round(v * 100);
  }

  function reprice(cart) {
    var savings = 0;
    (cart.items || []).forEach(function (item) {
      var disc = pidCents(item);
      if (disc == null || disc >= item.original_price) return;
      savings += (item.original_price - disc) * item.quantity;
      var row = document.querySelector('[data-cart-item="' + item.key + '"]');
      if (!row) return;
      var box = row.querySelector('.cart-item-price');
      if (!box) return;
      var fin = box.querySelector('.cart-item-final-price');
      if (!fin) return;
      var fullText = originalText(fin);          // "CHF 229.00" (stable per render)
      setNumber(fin, disc);                       // -> "CHF 160.30"
      var orig = box.querySelector('.cart-item-original-price');
      if (!orig) { orig = document.createElement('span'); orig.className = 'cart-item-original-price'; box.appendChild(orig); }
      orig.textContent = fullText;                // struck-through original
    });
    if (savings > 0) {
      var sub = document.querySelector('[data-cart-items-total]');
      if (sub) setNumber(sub, cart.items_subtotal_price - savings); // subtotal from cart data (idempotent)
      // Grand total = subtotal + shipping; reduce the ORIGINAL grand by the same savings.
      var grand = document.querySelector('[data-cart-total-price]');
      if (grand) {
        var og = originalCents(grand);
        if (og != null) setNumber(grand, og - savings);
      }
    }
  }

  function run() {
    fetch(cartUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (observer) observer.disconnect();
        reprice(cart);
        if (observer && target) observer.observe(target, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  // --- Mini-cart drawer (side drawer) -----------------------------------------
  // The drawer (snippets/side-drawer.liquid -> templates/cart.jsonData.liquid) is
  // a separate DOM tree from the /cart page: lines are `.media-link[data-line]`
  // (1-based index into cart.items) and the line price is `.yv-product-price`
  // showing the *line* total (item.final_line_price), not the unit price. It is
  // re-rendered by cart-ajax.js on open/qty-change, which clears our markers.
  var drawerObserver = null, drawerBody = null, drawerDebounce = null;

  function repriceDrawer(cart) {
    var wrap = document.querySelector('.yv_side_drawer_wrapper');
    if (!wrap) return;
    var savings = 0;
    (cart.items || []).forEach(function (item, i) {
      var disc = pidCents(item);                          // discounted UNIT price (cents)
      if (disc == null || disc >= item.original_price) return;
      savings += (item.original_price - disc) * item.quantity;
      var line = wrap.querySelector('.media-link[data-line="' + (i + 1) + '"]');
      if (!line) return;
      var priceEl = line.querySelector('.yv-product-price');
      if (!priceEl) return;
      var fullText = originalText(priceEl);               // full line price text (stable per render)
      setNumber(priceEl, disc * item.quantity);           // -> discounted LINE price
      var box = priceEl.closest('.yv-prizebox') || priceEl.parentNode;
      var cmp = box.querySelector('.yv-product-compare-price');
      if (!cmp) { cmp = document.createElement('span'); cmp.className = 'yv-product-compare-price'; box.appendChild(cmp); }
      cmp.textContent = fullText;                          // struck-through original
    });
    if (savings > 0) {
      var sub = wrap.querySelector('[data-cart-items-total]');
      if (sub) setNumber(sub, cart.items_subtotal_price - savings);  // subtotal from cart data (idempotent)
      var grand = wrap.querySelector('[data-cart-total-price]');     // grand = subtotal + shipping
      if (grand) {
        var og = originalCents(grand);
        if (og != null) setNumber(grand, og - savings);
      }
    }
  }

  function runDrawer() {
    fetch(cartUrl, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (drawerObserver) drawerObserver.disconnect();
        repriceDrawer(cart);
        if (drawerObserver && drawerBody) drawerObserver.observe(drawerBody, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  // The drawer lives in every page's layout (theme.liquid) but is filled in via
  // AJAX only when opened, so observe its (stable) body container for re-renders.
  function startDrawer() {
    drawerBody = document.querySelector('[data-drawer-body]');
    if (!drawerBody || !window.MutationObserver) return;
    drawerObserver = new MutationObserver(function () {
      clearTimeout(drawerDebounce);
      drawerDebounce = setTimeout(runDrawer, 200);
    });
    drawerObserver.observe(drawerBody, { childList: true, subtree: true });
  }

  function start() {
    startDrawer(); // drawer is global — set up regardless of whether this is a cart surface
    if (!document.querySelector('[data-cart-items]') && !document.querySelector('[data-cart-items-total]')) return; // not a cart surface
    run();
    // Re-run after the theme re-renders line items OR totals on qty/remove. We observe the
    // whole cart section so a theme total-update (which lands after our first pass) also
    // re-triggers us. Observer is disconnected during our own writes so we don't loop.
    target = document.querySelector('.cart-section') || document.querySelector('[data-cart-items]') || document.body;
    if (target && window.MutationObserver) {
      observer = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(run, 250);
      });
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
